import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Flex, Text, Alert, AlertIcon } from "@chakra-ui/react";
import {
  getPromo,
  deactivatePromo,
} from "../../../../../store/gifts/promoSlice";
import CreatePromoModal from "./CreatePromoModal";
import Pagination from "../../../../shared/pagination/Pagination";
import Table from "../../../../shared/table/Table";

const PromoList = () => {
  const dispatch = useDispatch();
  const promo = useSelector((s) => s.promo);
  const [page, setPage] = useState(1);
  const [showCreate, setShowCreate] = useState(false);

  useEffect(() => {
    dispatch(getPromo({ page }));
  }, [dispatch, page]);

  return (
    <>
      {promo.error && (
        <Alert status="error" mb={4}>
          <AlertIcon />
          {promo.error}
        </Alert>
      )}
      <Flex mb={4} justify="flex-start" gap={4}>
        <Button colorScheme="red" onClick={() => setShowCreate(true)}>
          Create
        </Button>
      </Flex>

      {promo.data?.length ? (
        <Table>
          <thead>
            <tr>
              <th>#</th>
              <th>Code</th>
              <th>Amount</th>
              <th>Expiration</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {promo.data.map((el, i) => (
              <tr key={el._id}>
                <td>{(page - 1) * 10 + (i + 1)}</td>
                <td>{el.code}</td>
                <td>{el.amount}</td>
                <td>{new Date(el.expirationDate).toLocaleDateString()}</td>
                <td>{el.status}</td>
                <td>
                  <Button
                    size="xs"
                    colorScheme="red"
                    variant="outline"
                    onClick={() =>
                      dispatch(deactivatePromo({ id: el._id })).then(() =>
                        dispatch(getPromo({ page }))
                      )
                    }
                  >
                    Deactivate
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Flex h="150px" align="center" justify="center">
          <Text color="gray.400">No data</Text>
        </Flex>
      )}

      <Flex justify="flex-end" mt={3}>
        <Pagination
          page={page}
          itemsCount={promo.itemsCount}
          onChange={setPage}
        />
      </Flex>

      {showCreate && (
        <CreatePromoModal
          onClose={() => {
            setShowCreate(false);
            dispatch(getPromo({ page: 1 }));
            setPage(1);
          }}
        />
      )}
    </>
  );
};

export default PromoList;
